export const meta = {
  appAlias: 'spinning-wheel',
  appName: 'Spinning Wheel'
};
